export default {
  MuiTabs: {
    styleOverrides: {
      root: {
        width: '100%',
        minHeight: '0px'
      },
      indicator: {
        height: '2px',
        display: 'flex',
        justifyContent: 'center',
        borderTopRightRadius: '0px',
        borderTopLeftRadius: '0px',
        backgroundColor: '#005DCC',
        '& > span': {
          maxWidth: 40,
          height: '1px',
          width: '100%',
          backgroundColor: '#005DCC'
        },
        bottom: '0px !important'
      },
      scroller: {
        overflow: 'auto !important'
      }
    }
  }
};
